import moment from "moment";
import { IBookingTimeProps } from "./types";
import DateUtilsService from 'external-services/date-utils-service';
import { LocaleService } from 'app/services/locale/locale.service';

/**
 * Extract and format the booking time from the booking date.
 */
export function DetermineBookingTime(props: IBookingTimeProps): string | null {

  const { bookingTime, fulldate } = props;

  // bookingTime must be specified
  if (bookingTime) {
    let time: Date | string = bookingTime;

    // check if bookingTime is a date object and if not, convert it to one
    if (!(time instanceof Date)) {
      time = DateUtilsService.dateTimeStrToDate(bookingTime as string);
    }

    // fulldate mode: show localised date + time (e.g. on the blockouts inline list)
    if (fulldate) {
      return LocaleService.formatDate(time, 'medium-short') + ' ' + moment(time).format('h:mma');
    }
    return moment(time).format('h:mma');
  }

  return null;
}

/**
 * Display the booking end time in error state (i.e. red colour), when the amended time is less than the default booking time.
 */
export function IsBookingEndTimeInvalid(duration: string | number, defaultDurationInMinutes: number) {

  return IsNumber(duration) ? (duration as number) < defaultDurationInMinutes : false;
}

/**
 * Do not display the booking end time for either of the below condtions:
 * 1. Switch is turned OFF
 * 2. The duration of the booking is less than an hour
 */
export function CanShowBookingEndTime(enableEndBookingTime: boolean, duration: string | number) {

  if (!enableEndBookingTime) return false;

  return IsNumber(duration) ? (duration as number) >= 60 : false;
}

/** Determines whether the specified value is a number or not. */
function IsNumber(value: any) {
  return typeof value === 'number'? true : false;
}
